module.exports = __webpack_public_path__ + "img/logo_vitech.43c66e80.png";